<template>
    <CompassDialog
        :visible.sync="visible"
        :close-on-click-overlay="false"
        size="small"
        :title="$t.__('email.disconnect_my_email')"
        overlayColor="dark"
        @closed="closeModal"
        class="disconnect-popup"
    >
        <template #default>
            <p class="disconnect-popup__text">
                {{
                    $l10n.__(
                        'En déconnectant votre compte email, les emails déjà envoyés et reçus sur Sellsy seront conservés mais vous ne pourrez plus en envoyer ou en recevoir des nouveaux.',
                    )
                }}
            </p>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    @click="closeModal"
                    type="secondary"
                    size="medium"
                ></CompassButton>
                <CompassButton
                    :label="$t.__('email.DisconnectPopup.confirm_and_disconnect')"
                    type="primary-destructive"
                    size="medium"
                    @click="logout"
                ></CompassButton>
            </div>
        </template>
    </CompassDialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            requred: true,
        },
    },
    methods: {
        logout() {
            this.$emit('handleDisconnect');
        },
        closeModal() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.disconnect-popup {
    &__text {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }
    .compass-dialog__modal__content {
        overflow-y: hidden;
        p {
            margin: 0;
        }
    }
    .compass-dialog__modal__footer {
        .dialog__footer {
            display: flex;
            flex-direction: row;
            gap: var(--spacing-3);
            justify-content: flex-end;

            padding: var(--spacing-4) var(--spacing-5) var(--spacing-5);
        }
    }
}
</style>
